import React, {
    useState,
    useEffect,
} from "react";
import { FootnoteTable } from "../Footnotes/FootnotesPage";
import { Poppy } from "../Footnotes/PopOver";
import { FOOTNOTES_TO_SHOW } from "./constants";

export const FieldPage = (statekoneprops) => {
    // console.log("PROPS OF PAGE: ", statekoneprops)
    const [page, setPage] = useState()
    const [metaData, setMetaData] = useState({})
    const [finalEngine, setFinalEngine] = useState()
    const [footNotes, setFootNotes] = useState({})
    const [stateKoneFieldsMapper, setStateKoneFieldsMapper] = useState({})
    const [K1TemplateId, setK1TemplateId] = useState()
    const [poppyState, setPoppyState] = useState(false)
    const [activeFootnote, setActiveFootnote] = useState("")
    const [activeFootnoteData, setActiveFootnoteData] = useState("")
    const [showFootnotesTable, setShowFootnotesTable] = useState(false)
    const [pageFileLink, setPageFileLink] = useState("")
    const heightConversionFactor = 709 / (statekoneprops.sectionDimensions?.height ?? 1);
    const widthConversionFactor = 550 / (statekoneprops.sectionDimensions?.width ?? 1);
    const leftOffset = (statekoneprops.sectionDimensions?.left ?? 70) - 70;


    /**
     * Capturing metadata changes to the active K-1 page
     */
    useEffect(() => {
        if (statekoneprops.metadata !== undefined) {
            setMetaData(statekoneprops.metadata)
        }
    }, [statekoneprops.metadata])

    /**
     * Update the page link on every page change
     */
    useEffect(() => {
        setPageFileLink(statekoneprops.filelink)
    }, [statekoneprops.filelink])

    /**
     * Update the flag to check if page needs to show Footnotes Table or regular Field Page
     */
    useEffect(() => {
        if (statekoneprops.showfootnotestable !== undefined) {
            // console.log("SHOW FOOTNOTES TABLE: ", statekoneprops.showfootnotestable)
            setShowFootnotesTable(statekoneprops.showfootnotestable)
        }
    }, [statekoneprops.showfootnotestable])

    /**
     * Update the Final Engine data for the active K-1 page
     */
    useEffect(() => {
        if (statekoneprops.finalenginedata !== undefined) {
            setFinalEngine(statekoneprops.finalenginedata)
        }
    }, [statekoneprops.finalenginedata])

    /**
     * Update the Footnotes data for the active K-1 page
     */
    useEffect(() => {
        if (statekoneprops.footnotes !== undefined && statekoneprops.footnotes !== null && Object.entries(statekoneprops.footnotes).length > 0) {
            // console.log("SETTING FOOTNOTES: ", statekoneprops.footnotes)
            setFootNotes(statekoneprops.footnotes)
        }
    }, [statekoneprops.footnotes])

    /** Update the page number for active K-1 page */
    useEffect(() => {
        if (statekoneprops.page !== undefined) {
            setPage(statekoneprops.page)
        }
    }, [statekoneprops.page])

    /**
     * Capture the change in Footnotes that have been edited by the user and update the Final Engine data accordingly
     */
    useEffect(() => {
        // console.log("LATEST FOOTNOTES: ", footNotes)
        if (footNotes !== undefined) {
            if (showFootnotesTable) {
                // console.log("TABLE FOOTNOTES: ", footNotes)
            } else {
                const skfm = Object.assign({}, stateKoneFieldsMapper)
                for (let [footnotes_field, footnotes_data] of Object.entries(footNotes)) {
                    const field_number = footnotes_field.split(".")[0]
                    const footnote_extract = footnotes_field.split(".")[1].split("-")[0]
                    for (let [mapper_field, mapper_value] of Object.entries(skfm)) {
                        if (mapper_field.includes(footnote_extract) && mapper_field.includes("- key")) {
                            const footnotesKeyToCheck = field_number + mapper_value
                            // console.log("FOOTNOTES KEY TO CHECK: ", footnotesKeyToCheck)
                            // console.log("FOOTNOTES DATA DATA: ", footnotes_data.data)
                            const requiredFootnote = footnotes_data.data.find((item) => item[0].toUpperCase().includes(footnotesKeyToCheck.toUpperCase()))
                            // console.log("REQUIRED FOOTNOTE: ", requiredFootnote)
                            if (requiredFootnote !== undefined) {
                                const valueToBeUpdatedToSkm = requiredFootnote[1]
                                // console.log("VALUE TO BE UPDATED: ", footnotesKeyToCheck)
                                const skfmFieldToUpdate = mapper_field.slice(0, -3) + "value"
                                skfm[skfmFieldToUpdate] = valueToBeUpdatedToSkm
                            } else {
                                continue
                            }
                        }
                    }
                }
                setStateKoneFieldsMapper(skfm)
            }
        }
    }, [footNotes])

    /**
     * Send the updated data on a page whenever page changes to keep it in cache
     */
    useEffect(() => {
        if (K1TemplateId !== undefined) {
            // console.log(K1TemplateId)
            statekoneprops.updatefields(statekoneprops.page, K1TemplateId, stateKoneFieldsMapper, footNotes)
        }
    }, [K1TemplateId])

    /**
     * Send the updated data on a page whenever data changes to update the cache
     */
    useEffect(() => {
        // console.log("STATE KONE FIELD MAPPER: ", stateKoneFieldsMapper)
        statekoneprops.updatefields(statekoneprops.page, K1TemplateId, stateKoneFieldsMapper, footNotes)
    }, [stateKoneFieldsMapper])

    /**
     * 
     */
    useEffect(() => {
        if (finalEngine !== undefined) {
            Object.assign(stateKoneFieldsMapper, finalEngine["result"])
            setStateKoneFieldsMapper(finalEngine["result"])
            setK1TemplateId(finalEngine["K1TemplateId"])
        }
    }, [finalEngine])

    /**
     * Function to captue the event and pass in data to popup renderer
     * @param {*} event : Captured right click event
     * @param {*} field : Field that was clicked on
     * @param {*} data : Footnotes data that needs to be shown in the popup
     */
    const onRightClick = (event, field, data) => {
        event.preventDefault()
        setActiveFootnote(field)
        setActiveFootnoteData(data)
        setPoppyState(true)
    }

    /**
     * Update the localized page footnotes using the footnote key and currewnt state of the data
     * @param {*} footnotekey : Footnote that needs to be updated
     * @param {*} updatedActiveFootnoteData : Modified data going into the footnotes
     */
    const updateActiveFootnoteData = (footnotekey, updatedActiveFootnoteData) => {
        setActiveFootnoteData(updatedActiveFootnoteData)
        const updated_footnotes = Object.assign({}, footNotes)
        const footnote_extract = footnotekey.split(".")[1].split("-")[0]
        // console.log("FOOTNOTE EXTRACT: ", footnote_extract)
        // console.log("UPDATED ACTIVE FOOTNOTE DATA: ", updatedActiveFootnoteData)
        // THIS IS A JUGAAD TO HADLE THE CURRENT WAY OF API RESPONSE WHERE WE GET FOOTOTES DATA FOR MULTIPLE KEYS
        for (let [field, footnotes] of Object.entries(updated_footnotes)) {
            if (field.includes(footnote_extract)) {
                footnotes["data"] = updatedActiveFootnoteData
            }
        }
        // console.log("UPDATED FOOTNOTES: ", updated_footnotes)
        setFootNotes(updated_footnotes)
    }

    /**
     * Function to update the final engine data based on changes that were done by the user
     * @param {*} field : Field to be updated in the final engine data map
     * @param {*} value : Final engine data map
     */
    const updateField = (field, value) => {
        setStateKoneFieldsMapper(skfm => ({ ...skfm, [field]: value }))
        // console.log("CHANGED MAP: ", {stateKoneFieldsMapper, [field]:value})
    }

    return (
        <>
            {
                showFootnotesTable === false ?
                    <>
                        <Poppy
                            show={poppyState}
                            onHide={() => setPoppyState(false)}
                            header={activeFootnote}
                            data={activeFootnoteData}
                            filelink={pageFileLink}
                            updatefootnotedata={(footnotekey, activefootnotedata) => updateActiveFootnoteData(footnotekey, activefootnotedata)}
                            setactivepage={(page) => statekoneprops.setactivepage(page)}
                        />
                        <div
                            style={{
                                position: "absolute",
                                boxShadow: "1px 1px 0px 1px rgba(240, 240, 240, 0.05)",
                                left: 0
                            }} >
                            {
                                Object.keys(metaData).length > 0 ?
                                    <>
                                        {
                                            Object.keys(metaData["Page 1"]["Checkbox Coordinates"]).map((field) =>
                                                <div style={{
                                                    position: "absolute",
                                                    zIndex: 1,
                                                    top: `${metaData["Page 1"]["Checkbox Coordinates"][field]["y"] / heightConversionFactor}px`,
                                                    left: `${leftOffset + metaData["Page 1"]["Checkbox Coordinates"][field]["x"] / widthConversionFactor}px`,
                                                    width: `${metaData["Page 1"]["Checkbox Coordinates"][field]["w"] / widthConversionFactor}px`,
                                                    height: `${metaData["Page 1"]["Checkbox Coordinates"][field]["h"] / heightConversionFactor}px`
                                                }}>
                                                    <input type="checkbox"
                                                        className={
                                                            stateKoneFieldsMapper[field] ?
                                                                metaData["Page 1"]["Checkbox Coordinates"][field]["ValidationData"] == "true" || metaData["Page 1"]["Checkbox Coordinates"][field]["ValidationData"] == true
                                                                    ?
                                                                    "kone-text-field-check field-changed-green"
                                                                    :
                                                                    "kone-text-field-check field-changed-red"
                                                                : "kone-text-field-check"}
                                                        style={{ textAlign: `${metaData["Page 1"]["Checkbox Coordinates"][field]["align"]}` }}
                                                        checked={stateKoneFieldsMapper[field] === "True" || stateKoneFieldsMapper[field] === "true" || stateKoneFieldsMapper[field] === true ? true : false}
                                                        onChange={(event) => updateField(field, event.target.checked)}
                                                        autoComplete="new-password"
                                                    />
                                                </div>
                                            )
                                        }
                                        {
                                            Object.keys(metaData["Page 1"]["Text Coordinates"]).map((field) => {
                                                if (stateKoneFieldsMapper[field] && stateKoneFieldsMapper[field].includes("\n")) {
                                                    return (
                                                        <div style={{
                                                            position: "absolute",
                                                            zIndex: 1,
                                                            top: `${metaData["Page 1"]["Text Coordinates"][field]["y"] / heightConversionFactor}px`,
                                                            left: `${leftOffset + metaData["Page 1"]["Text Coordinates"][field]["x"] / widthConversionFactor}px`,
                                                            width: `${metaData["Page 1"]["Text Coordinates"][field]["w"] / widthConversionFactor}px`,
                                                            height: `${metaData["Page 1"]["Text Coordinates"][field]["h"] / heightConversionFactor}px`
                                                        }}>
                                                            <textarea
                                                                type="textarea"
                                                                rows={3}
                                                                className={
                                                                    stateKoneFieldsMapper[field]
                                                                        ?
                                                                        (
                                                                            metaData["Page 1"]["Text Coordinates"][field]["ValidationData"] == "true" || metaData["Page 1"]["Text Coordinates"][field]["ValidationData"] == true
                                                                                ?
                                                                                "kone-text-field field-changed-green"
                                                                                :
                                                                                "kone-text-field field-changed-red"
                                                                        )
                                                                        :
                                                                        "kone-text-field"
                                                                }
                                                                style={{ textAlign: `${metaData["Page 1"]["Text Coordinates"][field]["align"]}` }}
                                                                value={stateKoneFieldsMapper[field]}
                                                                onChange={(event) => { updateField(field, event.target.value) }}
                                                                autoComplete="new-password"
                                                            />
                                                        </div>
                                                    )
                                                } else {
                                                    return (
                                                        <div style={{
                                                            position: "absolute",
                                                            zIndex: 1,
                                                            top: `${metaData["Page 1"]["Text Coordinates"][field]["y"] / heightConversionFactor}px`,
                                                            left: `${leftOffset + metaData["Page 1"]["Text Coordinates"][field]["x"] / widthConversionFactor}px`,
                                                            width: `${metaData["Page 1"]["Text Coordinates"][field]["w"] / widthConversionFactor}px`,
                                                            height: `${metaData["Page 1"]["Text Coordinates"][field]["h"] / heightConversionFactor}px`
                                                        }}>
                                                            {
                                                                Object.keys(footNotes !== undefined ? footNotes : {}).includes(field) && footNotes[field]["data"].length > 0 && FOOTNOTES_TO_SHOW.includes(field.slice(0, 2).toString())
                                                                    ?
                                                                    <input type="text"
                                                                        className={
                                                                            stateKoneFieldsMapper[field]
                                                                                ?
                                                                                (
                                                                                    metaData["Page 1"]["Text Coordinates"][field]["ValidationData"] == "true" || metaData["Page 1"]["Text Coordinates"][field]["ValidationData"] == true
                                                                                        ?
                                                                                        "kone-text-field field-changed-green has-footnotes"
                                                                                        :
                                                                                        "kone-text-field field-changed-red has-footnotes"
                                                                                )
                                                                                :
                                                                                "kone-text-field has-footnotes"
                                                                        }
                                                                        style={{ textAlign: `${metaData["Page 1"]["Text Coordinates"][field]["align"]}`, border: "3px solid black" }}
                                                                        value={stateKoneFieldsMapper[field]}
                                                                        onChange={(event) => { updateField(field, event.target.value) }}
                                                                        autoComplete="new-password"
                                                                        onContextMenu={(e) => onRightClick(e, field, footNotes[field])}
                                                                    />
                                                                    : <input type="text"
                                                                        className={
                                                                            stateKoneFieldsMapper[field]
                                                                                ?
                                                                                (
                                                                                    metaData["Page 1"]["Text Coordinates"][field]["ValidationData"] == "true" || metaData["Page 1"]["Text Coordinates"][field]["ValidationData"] == true
                                                                                        ?
                                                                                        "kone-text-field field-changed-green"
                                                                                        :
                                                                                        "kone-text-field field-changed-red"
                                                                                )
                                                                                :
                                                                                "kone-text-field"
                                                                        }
                                                                        style={{ textAlign: `${metaData["Page 1"]["Text Coordinates"][field]["align"]}` }}
                                                                        value={stateKoneFieldsMapper[field]}
                                                                        onChange={(event) => { updateField(field, event.target.value) }}
                                                                        autoComplete="new-password"
                                                                    />
                                                            }

                                                        </div>
                                                    )
                                                }
                                            })}
                                    </>
                                    :
                                    <></>
                            }
                        </div>
                    </>
                    :
                    <>
                        <div style={{
                            position: "absolute",
                            width: "43%",
                            height: "94%"
                        }}>
                            <FootnoteTable
                                page={page}
                                data={footNotes}
                                updatefootnotedata={(footnotekey, activefootnotedata) => updateActiveFootnoteData(footnotekey, activefootnotedata)}
                            />
                        </div>
                    </>
            }
        </>
    )
}
